module.exports = __webpack_public_path__ + "img/gitlab.5fcc086c.png";